import React from 'react';
import { LoadingOverlay } from "../../ab-common-legacy/LoadingOverlay";
import { AppProvider } from "./Providers";
import DsjStoreProvider from "../../store/DsjStoreProvider";
import Content from "./Content";
var CheckEligibilityFlowModal = function CheckEligibilityFlowModal(_ref) {
  var onClose = _ref.onClose,
    open = _ref.open,
    programId = _ref.programId,
    userId = _ref.userId,
    userRole = _ref.userRole,
    onSave = _ref.onSave,
    onSubmit = _ref.onSubmit,
    showSaveAndExitModal = _ref.showSaveAndExitModal,
    exploreAction = _ref.exploreAction,
    ineligibleRegisterRedirect = _ref.ineligibleRegisterRedirect;
  if (!open) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AppProvider, {
    userId: userId,
    userRole: userRole,
    programId: programId,
    onSubmit: onSubmit,
    showSaveAndExitModal: showSaveAndExitModal,
    exploreAction: exploreAction,
    ineligibleRegisterRedirect: ineligibleRegisterRedirect
  }, /*#__PURE__*/React.createElement(DsjStoreProvider, {
    id: userId,
    loadingElement: /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    })
  }, /*#__PURE__*/React.createElement(Content, {
    onClose: onClose,
    onSave: onSave
  })));
};
export default CheckEligibilityFlowModal;